/**
 * 工单回访实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-08
*/


import { useState } from 'react';
import { Modal, Input, message, Rate, DatePicker, Flex, Typography } from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, currentDate, } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dayjs from 'dayjs';
const MODULENAME = '工单回访'

const { TextArea } = Input;
const { Text } = Typography;

const MODULENAME_URL = CNF.navItems[2].submenu[1].url;

const Entity = (props) => {
    const { open, setOpen, refresh } = props;

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [visitDate, setVisitDate] = useState(currentDate);
    const [rate, setRate] = useState(5);
    const [evaluation, setEvaluation] = useState('');
    const [visitDisplayname, setVisitDisplayname] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setVisitDate(currentDate);
        setRate(5);
        setEvaluation('');
        setVisitDisplayname('');
        setDescription('');
    };


    const ok = () => {
        //  参数校验
        if (evaluation === '') {
            messageApi.error('客户评价不能为空！', CNF.messageDuration);
            return;
        }
        if (visitDisplayname === '') {
            messageApi.error('回访人员不能为空！', CNF.messageDuration);
            return;
        }
        setLoading(true);

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                wo_ulid: props.record.key,
                visit_date: visitDate,
                rate: rate,
                evaluation: evaluation,
                visit_displayname: visitDisplayname,
                description: description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false);
        }, CNF.messageDuration * 1000))
    };

    return (
        <>
            {contextHolder}
            <Modal
                width={500}
                title={MODULENAME}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Flex vertical gap='small'>
                    <Flex justify='space-between'>
                        <Flex vertical>
                            <Text>工单编号<Text type='danger'>*</Text></Text>
                            <Input
                                value={props.record.number}
                                disabled={true}
                            />
                        </Flex>
                        <Flex vertical>
                            <Text>回访时间<Text type='danger'>*</Text></Text>
                            <DatePicker
                                placeholder='请选择日期'
                                value={dayjs(visitDate, 'YYYY-MM-DD')}
                                style={{ width: '100%' }}
                                onChange={(_, dateString) => setVisitDate(dateString)}
                                disabled={loading}
                            />
                        </Flex>
                    </Flex>
                    <Flex vertical>
                        <Text>客户评分<Text type='danger'>*</Text></Text>
                        <Rate
                            style={{ fontSize: 15 }}
                            onChange={(value) => setRate(value)}
                            value={rate}
                            disabled={loading}
                        />
                    </Flex>
                    <Flex vertical>
                        <Text>客户评价<Text type='danger'>*</Text></Text>
                        <TextArea
                            placeholder='请输入'
                            autoSize={{ minRows: 2, maxRows: 4 }}
                            onChange={(e) => setEvaluation(e.target.value)}
                            value={evaluation}
                            disabled={loading}
                        />
                    </Flex>
                    <Flex vertical>
                        <Text>回访人员<Text type='danger'>*</Text></Text>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setVisitDisplayname(e.target.value)}
                            value={visitDisplayname}
                            disabled={loading}
                        />
                    </Flex>
                    <Flex vertical>
                        <Text>回访备注</Text>
                        <TextArea
                            placeholder='备注可请在这里....'
                            autoSize={{ minRows: 2, maxRows: 4 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                            disabled={loading}
                        />
                    </Flex>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity